import { render } from "./AdminDashboard.vue?vue&type=template&id=2347eca6&scoped=true"
const script = {}

import "./AdminDashboard.vue?vue&type=style&index=0&id=2347eca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2347eca6"]])

export default __exports__